import { message } from 'antd'
import { GetServerSideProps } from 'next'
import Router from 'next/router'
import { SEOHead } from '~/components/business/SEOHead'
import { GlobalRequest } from '~/components/global-request'
import { MyContainer } from '~/components/ui/MyContainer'
import { labList } from '~/configs/ai'
import { Layout } from '~/layouts/default'
import { toCDNImage } from '~/utils'

const AILab = () => {
  return (
    <Layout>
      <SEOHead title="AI实验室" />
      <div
        className="w-full h-[260px] -mt-6 !bg-cover !bg-center relative"
        style={{
          background: `url(${toCDNImage('/images/lab/header-bg.jpg')})`,
        }}
      >
        <div className="absolute top-0 right-0 left-0 bottom-0 bg-neutral-50/30">
          <MyContainer>
            <div className="text-[40px] leading-[48px] text-neutral-900 font-semibold pt-[170px]">
              AI 实验室
            </div>
          </MyContainer>
        </div>
      </div>

      <MyContainer className="flex flex-wrap gap-4 !py-6">
        {labList.map(i => {
          return (
            <div
              key={i.title}
              className="w-[453px] flex items-center justify-between p-4 rounded-2xl border-solid border-neutral-100 border-2 hover:border-primary cursor-pointer transition-all bg-neutral-900/[0.04]"
              onClick={e => {
                if (i.link) {
                  Router.push(i.link)
                } else {
                  message.destroy()
                  message.info('敬请期待')
                }
              }}
            >
              <div>
                <div className="text-[22px] leading-[32px] font-semibold text-neutral-500 mb-2 relative">
                  {i.title}
                </div>
                <div className="text-neutral-500 text-xs">{i.desc}</div>
              </div>
              <div className="relative">
                <div className=" rounded-lg overflow-hidden flex flex-wrap flex-shrink-0 ml-4 w-[160px]">
                  {i.imgs.slice(0, 4).map((j, index) => {
                    return (
                      <img
                        key={index}
                        src={j}
                        alt=""
                        className="block w-20 h-20"
                      />
                    )
                  })}
                </div>
                {i?.isNew && (
                  <img
                    className="h-[14px] absolute -top-2 -right-2"
                    src="/images/ai/new.png"
                    alt=""
                  />
                )}
              </div>
            </div>
          )
        })}
      </MyContainer>
    </Layout>
  )
}

export default AILab

export const getServerSideProps: GetServerSideProps = async context => {
  /** 必须调用这个，不然无法初始化mobx
   *  复现方式：
   *   - 注释掉getServerSideProps函数
   *   - safari 浏览器页面点击登录注册，无法弹出登录框
   */
  const { initialState } = await GlobalRequest(context)

  return {
    props: {
      initialState,
    },
  }
}
